import { useState } from 'react';
import type { ProviderPreset } from '@momomail/shared';
import { AccountForm, ProviderPicker } from './AccountForm';
import { Icon } from './Icon';
import { Mascot } from './Mascot';
import { t } from '../lib/i18n';

/** First launch with no accounts yet: one big sticker — pick a provider → fill in the account. */
export function Welcome({ presets, mode }: { presets: ProviderPreset[]; mode: 'local' | 'remote' | 'browser' }) {
  const [preset, setPreset] = useState<ProviderPreset | null>(null);
  return (
    <main className="welcome">
      <div className="welcome__card">
        {!preset ? (
          <>
            <div className="welcome__hero">
              <div className="welcome__art" aria-hidden>
                <Mascot />
              </div>
              <div>
                <h1 className="welcome__title">{t('欢迎使用馍馍邮箱')}</h1>
                <p className="welcome__lead">
                  {t('把几个邮箱放在一起收：工作的、个人的，一个窗口全看见。')}
                  {mode === 'browser' ? t('邮件由服务器一直在收，打开网页就能看。') : t('关掉窗口它会待在托盘里，新邮件照样提醒你。')}
                </p>
              </div>
            </div>
            <h2 className="welcome__step">
              <span className="welcome__num">1</span> {t('先添加一个邮箱')}
            </h2>
            <ProviderPicker presets={presets} onPick={setPreset} />
            <p className="muted welcome__privacy">
              <Icon name="lock" size={14} /> {mode === 'local' ? t('密码加密保存在这台电脑上（密钥由系统保护），邮件也只缓存在本机。') : t('密码加密保存在你的馍馍邮箱服务器上，邮件也存在那里。')}
            </p>
          </>
        ) : (
          <>
            <button className="settings__back" onClick={() => setPreset(null)}>
              <Icon name="back" size={15} /> {t('换个服务商')}
            </button>
            <h2 className="welcome__step">
              <span className="welcome__num">2</span> {t('填写 {provider} 账户', { provider: preset.label })}
            </h2>
            <AccountForm presets={presets} preset={preset} account={null} onCancel={() => setPreset(null)} onSaved={() => setPreset(null)} compact />
          </>
        )}
      </div>
    </main>
  );
}
